import isEmpty from 'lodash/isEmpty';

import {
  PERMISSIONS_MODULES,
  PERMISSIONS_MODULES_ID,
  PERMISSIONS_OPTIONS_VALUE
} from 'constants/team-members';

const { NO_ACCESS } = PERMISSIONS_OPTIONS_VALUE;

export const fillRestOfPermissionsBySpecificAccess = ({
  permissions,
  specificAccess
}) => {
  const filledPermissions = { ...permissions };

  PERMISSIONS_MODULES.forEach(({ apiKey, defaultAccess }) => {
    const currentPermission = filledPermissions[apiKey];

    if (!currentPermission || currentPermission === NO_ACCESS) {
      filledPermissions[apiKey] = specificAccess || defaultAccess;
    }
  });

  return filledPermissions;
};

export const getFullName = ({ firstName, lastName }) =>
  `${firstName} ${lastName}`.trim();

export const isAllPermissionsSelected = (permissions) => {
  const { PRODUCT_CATEGORY, PICKUPS, ...rest } = PERMISSIONS_MODULES_ID;
  const values = Object.values(rest);

  for (let i = 0; i < values.length; i++) {
    const currValue = permissions[values[i]];
    if (!currValue || currValue === NO_ACCESS) {
      return false;
    }
  }

  return true;
};

export const hasNoSelectedPermissions = (permissions) => {
  if (isEmpty(permissions)) {
    return true;
  }
  const { PRODUCT_CATEGORY, PICKUPS, ...rest } = PERMISSIONS_MODULES_ID;
  const values = Object.values(rest);

  for (let i = 0; i < values.length; i++) {
    const currValue = permissions[values[i]];
    if (currValue && currValue !== NO_ACCESS) {
      return false;
    }
  }

  return true;
};
